export const environment = {
    production: false,
    appwrite: {
      endpoint: 'https://cloud.appwrite.io/v1',
      projectId: '669e0f23003074c98214',
      databaseId: '66aa219f0016da61d608',
      categoriesCollectionId: '66aa225f001c60c3e322',
      countyCollectionId: '66cb89940021cf9bdfe2',
    }
  };